import { render, staticRenderFns } from "./ReplacementVehicleTiresFilter.vue?vue&type=template&id=5bca5f7e&"
import script from "./ReplacementVehicleTiresFilter.vue?vue&type=script&lang=js&"
export * from "./ReplacementVehicleTiresFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports